// src/PrivacyPolicy.jsx
import React from "react";

function PrivacyPolicy() {
  return (
    <div className="landing-root">
      <div className="background-particles" />

      <section className="landing-section glass-card" style={{ maxWidth: "900px", margin: "140px auto 40px" }}>
        <h2 className="neon-title">Multiversal Blockchain Tracer</h2>       
        <h2 className="neon-title">Privacy Policy</h2>
        <p className="section-subtitle">Last updated: {new Date().toLocaleDateString()}</p>

        <p>
          Multiversal Blockchain Tracer (“we”, “our”, or “the dApp”) is built to provide
          transparent, anonymous insights into public blockchain data. Protecting user
          trust and privacy is a core principle of this project.
        </p>

        <h3>1. Information We Collect</h3>
        <ul>
          <li>Email address (for account creation, verification, and access control)</li>
          <li>Basic authentication metadata (account creation & verification status)</li>
        </ul>

        <h3>2. What We Do <strong>Not</strong> Collect</h3>
        <ul>
          <li>Private keys or seed phrases</li>
          <li>Wallet passwords or signing permissions</li>
          <li>Transaction approvals or wallet connections</li>
          <li>Stored wallet balances tied to user accounts</li>
        </ul>

        <h3>3. Wallet & ENS Data Usage</h3>
        <p>
          Wallet addresses and ENS names entered into the dApp are public blockchain data.
          They are processed temporarily to display balances and insights and are not
          stored, logged, or linked to user accounts.
        </p>

        <h3>4. AI & SmartInsight Disclaimer</h3>
        <p>
          This dApp includes analytical and AI-inspired features such as scores,
          classifications, and recommendations. These features are informational only and
          do <strong>not</strong> constitute financial advice, investment guidance, or
          guarantees of performance.
        </p>

        <h3>5. Cookies & Analytics</h3>
        <p>
          We do not use advertising cookies. Limited analytics may be used to understand
          platform usage (such as page visits or feature usage) and are never linked to
          wallet addresses.
        </p>

        <h3>6. Third-Party Services</h3>
        <p>
          We rely on trusted third-party providers such as Firebase (authentication),
          Covalent (blockchain data), and CoinGecko (market data). These services operate
          under their own privacy policies.
        </p>

        <h3>7. Data Security</h3>
        <p>
          We use industry-standard security practices including HTTPS, secure
          authentication, and minimal data retention to protect user information.
        </p>

        <h3>8. Your Rights</h3>
        <p>
          You may stop using the service at any time or request account deletion by
          contacting us. We respect user autonomy and data control.
        </p>

        <h3>9. Contact</h3>
        <p>
          For privacy-related questions or concerns, please contact:
          <br />
          <strong>📧 MetaAgentID@gmail.com</strong>
        </p>

        <h3>10. Policy Updates</h3>
        <p>
          Any changes to this Privacy Policy will be reflected on this page with an updated
          revision date.
        </p>

        <p style={{ marginTop: "1.5rem", opacity: 0.85 }}>
          <em>Transparency is our foundation.</em>
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
